var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollable only-y"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-base card-shadow--medium p-30 content-terms"},[_c('div',{staticClass:"terms",domProps:{"innerHTML":_vm._s(_vm.terms)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }